// Every line is padded to the same width so the background renders as a rectangle
const PORTRAIT = [
  '                                                                                          ',
  '                                    ..::---=====---                                       ',
  '                                 ...:::::------=====--                                    ',
  '                             .::-:-:--------------====-=                                  ',
  '                           .:-::--------:----------===---+#                               ',
  '                         .:-------------::------------=----**                             ',
  '                       .::-----:::::-::::::::---------------+*                            ',
  '                      .::-:::::::::::::::::::::::--:-:::---:-=*                           ',
  '                     :.::::::::::::::::::::::::::::::::::---:-*-                          ',
  '                    .::::::::::::::::::.::::::::::::::::::::::=+                          ',
  '                    :::::::::::::::::::::::::::::::::::::::::::*#                         ',
  '                   ...:::...::.::::::::::::::::::::::::::::::.:=#                         ',
  '                   ...:::.:.::.::::::::::::::::::::::::::::...:==                         ',
  '                   .:.:.:::-==+=-:::::::-::--=----:::::::..:..---                         ',
  '                  *+*=+**#&&&&&&&#*==---=*##&@@@@@##**+=---=+#&@&=                        ',
  '                 =-&.-==+*#=@&&#***@##&#@+++***###***+++@@*++=+=::=#:                     ',
  '               &--.&.-==**+=+##*#*+@:--=@=+#&*=#&&-###==@.::::=---:*=                     ',
  '               #::.+=-==-====+**=-@+::--#@+=***+=+=++++=&:--::-**:-+-*                    ',
  '               @:=:.*+-:--------:@=------#@--=======--:++---::=*&+=-=+                    ',
  '              @+-*-:::==++++++++#---==---==&*+*****++++=:--::-+=##+-=+                    ',
  '              @::-+-::::::::::-++:------::-=#=::::::::::::::=++#==:==+                    ',
  '               =::-=.:::::::--++-=+-===-+*===++=--:::::::-::#*#+--=-*                     ',
  '               @-:-+-::::::-=*==-=+*+**+**+==+=++=----:-:--=##*+=--+                      ',
  '                @+--*-:-::-+#*+**&&#&&&*#&#&#*&***=-:---==*+###*=-                        ',
  '                ###=#+=-::-&**#*++++****###***#####--+**+**##*+*                          ',
  '                  #+*##===-#*+#**+++*******+*##&##&=++#&#&#*#*+#                          ',
  '                    =*#+**+=*+==-:--=-==--=--===*#==+##&#&*##+#@                          ',
  '                     +#&*#&+++=----=++*++==----+****#&&&*##&**@                           ',
  '                       &&#@#&&*+-----=+==----==*&&&&@@#&#&##+@@                           ',
  '                        &@@@@&&#+*====+++==++**#@@@@@@&@&&@+:@                            ',
  '                          &&@@&&#&#*+*&&*###&@&@@@@@@&@@@#-.:@@                           ',
  '                           &@@&*&##&&&&&&&&&@&@@@@@&@@#+:...+@@@@@                        ',
  '                           @+@@@@#&@@@@@@@&&@@@@@@@#+-::::.:@@@@@@@@@                     ',
  '                         :#@&.*@@@@@@@@@@@@@@@@@&#*=::::..-@@@@@@@@@@@@#+                 ',
  '                   .....=+#@@.:-+&@@@@@@@@@@&#***=::::::.=@@@@@@@@@@@@@@@@#**             ',
  '            ..:.......*@=**@@=:::--=++**++++===-::::::::*@@@@@@@@@@@@@@@@@@@@@@@          ',
  '         ...........:@@=*#*@@@----:--=======-:::::::::-&@@@@@@@@@@@@@@@@@@@@@@@@@@        ',
  '     .............:=#==**##@@@+=+----===+=-:::::::::--@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@      ',
  '...............-::-=:=++*##@@@&+=======-:::::::::---=@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@    ',
  '..............:..:&+@-=**##@@@&*===--=:::::::::::-=#@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '.:::........=-.::*@*+-++*#&@@@&#--:--#*#+.:::-::-=@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '----:.....:-:.::#@@+:===**#@@@&-:-===+=#&#=::::-=@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '-===-::.:---:::#@@&&@:==*##*@&------==+++=++=::#@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '=+++=-.:-=--==&@@@@&==:-*#*+@@.---==++==-=-=++#@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '=+**=-===--#*@@@@@#==--++++=@@.=+++=---------&@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '=+##*+++==&#@@@@@#==----==----=------::-----@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '+#@&*#*++&&@@@@@*---:-----::::::::::::::---@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '*&@@&#**&@@@@@@+---:.--::-::::::.::::::-:*@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '*&@@@&#@@@@@@@*----...-::::::.::::::::::*@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '#@@@@@@@@@@@@*=---....:--...:::::::::::@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '                                                                                          '
].join('\n')

// DevTools draws each line as its own box with this style, so vertical padding would stretch the portrait.
// 14px rows clear the console's own 13.2px line height; the art is generated for an 11px Menlo cell of 6.62x14px.
const STYLE = [
  'padding: 0 8px',
  'background: #ffffff',
  'color: #1b1b1b',
  'font: 11px/14px Menlo, Consolas, "DejaVu Sans Mono", monospace'
].join(';')

export function printConsolePortrait() {
  console.info(`%c${PORTRAIT}`, STYLE)
}
